import InputPrimary from "../Input";
import { useTranslation } from "react-i18next";

export default function InputNewPass({ newPassValue, setNewPassValue }) {
  const { t } = useTranslation();
  const handleChange = (e) => {
    setNewPassValue(e.target.value);
  };
  return (
    <InputPrimary
      placeholder={t("new_pass")}
      type="password"
      value={newPassValue}
      onChange={handleChange}
    />
  );
}
